export const UF_NAMES = {
  AC: 'Acre',
  AL: 'Alagoas',
  AM: 'Amazonas',
  AP: 'Amapá',
  BA: 'Bahia',
  CE: 'Ceará',
  DF: 'Distrito Federal',
  ES: 'Espírito Santo',
  GO: 'Goiás',
  MA: 'Maranhão',
  MG: 'Minas Gerais',
  MS: 'Mato Grosso do Sul',
  MT: 'Mato Grosso',
  PA: 'Pará',
  PB: 'Paraíba',
  PE: 'Pernambuco',
  PI: 'Piauí',
  PR: 'Paraná',
  RJ: 'Rio de Janeiro',
  RN: 'Rio Grande do Norte',
  RO: 'Rondônia',
  RR: 'Roraima',
  RS: 'Rio Grande do Sul',
  SC: 'Santa Catarina',
  SE: 'Sergipe',
  SP: 'São Paulo',
  TO: 'Tocantins',
};

export const PANEL_COLORS = {
  primary: '#ea580c',
  info: '#2563eb',
  success: '#10b981',
  danger: '#ef4444',
  warning: '#dc2626',
  neutral: '#64748b',
};

const CARGO_META = {
  prefeitos: { singular: 'prefeito', label: 'Prefeito', plural: 'Prefeitos' },
  vereadores: { singular: 'vereador', label: 'Vereador', plural: 'Vereadores' },
  governadores: { singular: 'governador', label: 'Governador', plural: 'Governadores' },
  presidentes: { singular: 'presidente', label: 'Presidente', plural: 'Presidentes' },
  senadores: { singular: 'senador', label: 'Senador', plural: 'Senadores' },
  deputados_federais: { singular: 'deputado federal', label: 'Deputado Federal', plural: 'Deputados Federais' },
  deputados_estaduais: { singular: 'deputado estadual', label: 'Deputado Estadual', plural: 'Deputados Estaduais' },
  deputados_distritais: { singular: 'deputado distrital', label: 'Deputado Distrital', plural: 'Deputados Distritais' },
};

export function getElectionValue(eleicao) {
  return typeof eleicao === 'object' ? String(eleicao.ano || '') : String(eleicao || '');
}

export function parseElectionValue(value) {
  const match = String(value || '').match(/^(\d{4})(?:_(\d+))?$/);
  return {
    year: match ? Number(match[1]) : Number(value) || 0,
    turn: match && match[2] ? Number(match[2]) : 1,
    raw: String(value || ''),
  };
}

export function compareElectionValues(a, b) {
  const left = parseElectionValue(getElectionValue(a));
  const right = parseElectionValue(getElectionValue(b));
  return left.year - right.year || left.turn - right.turn || left.raw.localeCompare(right.raw, 'pt-BR');
}

export function formatElectionLabel(value) {
  const raw = String(value || '').trim();
  const match = raw.match(/^(\d{4})_(\d+)$/);
  if (match) return `Eleição ${match[1]} — ${Number(match[2])}º turno`;
  return raw ? `Eleição ${raw}` : 'Eleição';
}

export function getCargoMeta(cargoKey) {
  const normalizedKey = String(cargoKey || '')
    .replace(/^raiox_/, '')
    .trim();
  if (CARGO_META[normalizedKey]) return CARGO_META[normalizedKey];

  const readable = normalizedKey.replace(/_/g, ' ');
  const singular = readable.replace(/s$/, '');
  return {
    singular: singular || readable || 'cargo',
    label: titleCase(singular || readable || 'cargo'),
    plural: titleCase(readable || 'cargos'),
  };
}

function titleCase(str) {
  return String(str || '').replace(/\b\w/g, c => c.toUpperCase());
}
